import { useNode } from '@craftjs/core';
import { Stack, TextField } from '@mui/material';
import useResponsiveValues, { ResponsiveValue } from '@/components/editor/hooks/useResponsiveValues';

export interface CssClass {
  cssClass?: string | ResponsiveValue<string>;
}

const ClassSettings = () => {
  const {
    props,
    actions: { setProp },
  } = useNode((node) => ({
    props: node.data.props,
  }));

  const responsive = useResponsiveValues();

  return (
    <Stack spacing={2}>
      <TextField
        label="Clases CSS"
        size="small"
        value={responsive.getValue(props.cssClass)}
        onChange={(e) => {
          setProp((props: CssClass) => {
            props.cssClass = responsive.setValue(props.cssClass, e.target.value);
            return props;
          });
        }}
      />
    </Stack>
  );
};

export default ClassSettings;
